import { Group, Text } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { useState } from 'react';
import { IUser, Json } from '../../types';
import ExtraButton from '../ExtraButton/ExtraButton';
import UserButtonLoader from '../UserButtonLoader/UserButtonLoader';
import UserMenu from '../UserMenu/UserMenu';
import classes from './NavBarMain.module.css';
import { Wrapper } from './NavBarMain.style';
import { filter } from './NavBarMain.utils';

export type NavBarMainProps = {
  data: {
    user: IUser;
    isSlimVersion?: boolean;
    isLoading: boolean;
    isEmployee: boolean;
    navItems: Json;
  };
  callbacks: {
    onNavigate: (path: string) => void;
  };
};

export function NavBarMain(props: NavBarMainProps) {
  const { data, callbacks } = props;
  const { user, isEmployee, navItems: groups, isLoading, isSlimVersion } = data;

  const [active, setActive] = useState('Billing');

  const { email, isPayingUser, isVisitor } = user;

  function renderCollectionLink(item: any, index: number) {
    const Icon = (icons as any)[item.icon];

    if (item.type === 'divider') {
      return <div key={index} className={classes.divider} />;
    }

    return (
      <a
        className={classes.link}
        data-active={item.label === active || undefined}
        href={item.path}
        key={item.label}
        onClick={(event) => {
          event.preventDefault();
          setActive(item.label);
          callbacks.onNavigate(item.path);
        }}
      >
        <Icon className={classes.linkIcon} stroke={1.5} />
        <span>{item.label}</span>
      </a>
    );
  }

  function renderCollectionLinks(links: any[]) {
    return links
      .filter((link) =>
        filter(link, {
          isSlimVersion,
          isEmployee,
          isPayingUser,
          isVisitor,
        })
      )
      .map((link, index) => renderCollectionLink(link, index));
  }

  function renderGroup(group: Json) {
    return (
      <div key={group.id} className={classes.section}>
        <Group className={classes.collectionsHeader} justify='space-between'>
          <Text size='xs' fw={500} c='dimmed'>
            {group.title}
          </Text>
        </Group>
        <div className={classes.collections}>{renderCollectionLinks(group.items)}</div>
      </div>
    );
  }

  function renderGroups() {
    return groups
      .filter((group: Json) =>
        filter(group, {
          isSlimVersion,
          isEmployee,
          isPayingUser,
          isVisitor,
        })
      )
      .map((group: Json) => renderGroup(group));
  }

  function renderUserButton() {
    if (isVisitor) {
      return null;
    }

    if (isLoading) {
      return <UserButtonLoader />;
    }

    return <UserMenu user={user} />;
  }

  return (
    <Wrapper className='NavBarMain-wrapper' data-testid='NavBarMain-wrapper'>
      <nav className={classes.navbar}>
        {renderUserButton()}

        <div className={classes.navbarMain}>{renderGroups()}</div>
        <div className={classes.footer}>
          <ExtraButton onNavigate={callbacks.onNavigate} />
        </div>
      </nav>
    </Wrapper>
  );
}

export default NavBarMain;
